"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasScore = void 0;
const hasScore = (score) => {
    if (score === 0)
        return true;
    return !!score && score !== '?' && score !== 'NR';
};
exports.hasScore = hasScore;
exports.default = exports.hasScore;
//# sourceMappingURL=has-score.js.map